import { Validator } from 'formstate';

export const passwordValidator: Validator<string> = (value) => {
    if (typeof value !== 'string' || value.length === 0) {
        return 'required';
    }

    if (value.length < 8) {
        return 'length';
    }

    if (!/[a-z]/i.test(value)) {
        return 'needsLetter';
    }

    if (!/\d/.test(value)) {
        return 'needsNumber';
    }
};

// Copied from app repo's Util\EmailUtils.cs
/* tslint:disable-next-line */
const EMAIL_REGEXP =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const emailValidator: Validator<string> = (value) => {
    if (typeof value !== 'string' || value.length === 0) {
        return 'required';
    }

    return EMAIL_REGEXP.test(value) ? false : 'email';
};
